"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const data_field_types_1 = __importDefault(require("../enums/data-field-types"));
const model_env_scopes_1 = __importDefault(require("../enums/model-env-scopes"));
const model_scopes_1 = __importDefault(require("../enums/model-scopes"));
const GraphandFieldBoolean_1 = __importDefault(require("../lib/fields/GraphandFieldBoolean"));
const GraphandFieldDate_1 = __importDefault(require("../lib/fields/GraphandFieldDate"));
const GraphandFieldJSON_1 = __importDefault(require("../lib/fields/GraphandFieldJSON"));
const GraphandFieldNumber_1 = __importDefault(require("../lib/fields/GraphandFieldNumber"));
const GraphandFieldRelation_1 = __importDefault(require("../lib/fields/GraphandFieldRelation"));
const GraphandFieldScope_1 = __importDefault(require("../lib/fields/GraphandFieldScope"));
const GraphandFieldText_1 = __importDefault(require("../lib/fields/GraphandFieldText"));
const GraphandField_1 = __importDefault(require("../lib/GraphandField"));
const GraphandModel_1 = __importDefault(require("../lib/GraphandModel"));
/**
 * @class DataField
 * @augments GraphandModel
 * @classdesc DataField model. Use {@link GraphandClient#getModel client.getModel("DataField")} to use this model
 */
class DataField extends GraphandModel_1.default {
    toGraphandField() {
        const { type, configuration } = this;
        let field;
        switch (type) {
            case "Text":
                field = new GraphandFieldText_1.default(configuration);
                break;
            case "Relation":
                field = new GraphandFieldRelation_1.default(configuration);
                field.query = configuration.initialQuery;
                break;
            case "Date":
                field = new GraphandFieldDate_1.default(configuration);
                break;
            case "Boolean":
                field = new GraphandFieldBoolean_1.default(configuration);
                break;
            case "Number":
                field = new GraphandFieldNumber_1.default(configuration);
                break;
            case "JSON":
                field = new GraphandFieldJSON_1.default(configuration);
                break;
            default:
                field = new GraphandField_1.default(configuration);
                break;
        }
        field.__dataField = this;
        return field;
    }
}
DataField._customFields = {};
DataField.apiIdentifier = "data-fields";
DataField.baseUrl = "/data-fields";
DataField.scope = model_scopes_1.default.DataField;
DataField.envScope = model_env_scopes_1.default.ENV;
DataField.schema = {
    name: new GraphandFieldText_1.default(),
    slug: new GraphandFieldText_1.default(),
    type: new GraphandFieldText_1.default({ options: Object.values(data_field_types_1.default) }),
    exclude: new GraphandFieldBoolean_1.default({ defaultValue: false }),
    configuration: new GraphandFieldJSON_1.default(),
    scope: new GraphandFieldScope_1.default(),
};
DataField.Types = data_field_types_1.default;
exports.default = DataField;
